<template>
  <div class="signup">

    <div class="container">
      <button class="signup__back" @click="goBack"></button>
      <img class="signup__artwork" src="../assets/img/signup.png" alt="">
    </div>

    <div class="container">
      <transition mode="out-in" name="fade">
        <p 
          class="signup__text"
          v-if="!showForm && !success && !error"
        >
          Add your brick to this ever-growing Yellow Brick Road today and be sure to look out for a special surprise in your inbox from the Rocket Man himself.        </p>
      </transition>
    </div>

    <transition mode="out-in" name="fade">
      <div
        v-if="!showForm"
        class="signup__logins container container--wide"
      >
        <div class="signup__ctas">
          <div class="signup__login-cta">
            <facebook-login
              class="button button--facebook"
              :appId="facebookAppId"
              @login="facebookLogin"
              @sdk-loaded="facebookSdkLoaded"
            />
          </div>
          <div class="signup__login-cta">
            <GoogleLogin
              :params="{ client_id: googleClientId }"
              :onSuccess="googleSuccess"
              cookiePolicy="single_host_origin"
            >
              Add with Google
            </GoogleLogin>
          </div>
          <div class="signup__login-cta">
            <button 
              class="button button--spotify"
              @click="login"
            >
              Add with Spotify
            </button>
          </div>
        </div>
        <button @click="setShowForm" class="button button--link">Or Add your brick via email</button>
      </div>
    </transition>

    <transition mode="out-in" name="fade">
      <div 
        class="signup__formwrap container container--wide" 
        v-if="showForm && !success && !error"
      >

        <div class="signup__brick">
          <div class="signup__select">
            <div class="signup__slider">
              <div class="signup__controls">
                <button
                  @click="setBrick('prev')"
                  class="signup__button signup__button--left"
                ></button>
                <div class="signup__label">Brick style</div>
                <button
                  @click="setBrick('next')"
                  class="signup__button signup__button--right"
                ></button>
              </div>
              <div class="signup__options">
                <div class="signup__option">
                  <div class="signup__brick-bg">
                    <transition mode="in-out" name="fade-brick">
                      <img v-show="brickType == 1" src="../assets/1024/texture-brick-1-top.jpg" alt="">
                    </transition>
                    <transition mode="in-out" name="fade-brick">
                      <img v-show="brickType == 2" src="../assets/1024/texture-brick-2-top.jpg" alt="">
                    </transition>
                    <transition mode="in-out" name="fade-brick">
                      <img v-show="brickType == 3" src="../assets/1024/texture-brick-3-top.jpg" alt="">
                    </transition>
                  </div>
                  <div class="signup__brick-name">
                    {{brickLabel[0]}}
                    <br/>
                    {{brickLabel[1]}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button 
            class="button button--primary signup__cta signup__cta--desktop"
            type="submit"
            form="signup-form"
            :disabled="!terms"
            v-if="!submitting"
          >
            Add brick now!
          </button>
          <div v-else class="signup__loader signup__cta--desktop"></div>
        </div>

        <form id="signup-form" @submit="onSubmit" class="signup__form form">

          <h2 class="signup__title">Your details</h2>

          <div class="form__field-group">
            <div :class="['form__field', errors.firstName && 'form__field--error']">
              <label for="firstName">Forename</label>
              <input type="text" name="firstName" v-model="firstName" />
              <p class="form__errors" v-if="errors.firstName">
                {{ errors.firstName }}
              </p>
            </div>
            <div :class="['form__field', errors.lastName && 'form__field--error']">
              <label for="lastName">Surname</label>
              <input type="text" name="lastName" v-model="lastName" />
              <p class="form__errors" v-if="errors.lastName">
                {{ errors.lastName }}
              </p>
            </div>
          </div>

          <div :class="['form__field', errors.email && 'form__field--error']">
            <label for="email">Email</label>
            <input name="email" type="email" v-model="email" placeholder="name@example.com" />
            <p class="form__errors" v-if="errors.email">{{ errors.email }}</p>
          </div>

          <div class="form__field-group">
            <div :class="['form__field', errors.country && 'form__field--error']">
              <label for="country">Country</label>
              <select name="country" type="text" v-model="country" :class="!country && 'select--placeholder'">
                <option disabled value="">Please Select</option>
                <option
                  v-for="(country, code) in countries"
                  :key="code"
                  :value="code"
                  >{{ country }}</option
                >
              </select>
              <p class="form__errors" v-if="errors.country">
                {{ errors.country }}
              </p>
            </div>
            <div :class="['form__field', errors.region && 'form__field--error']">
              <label for="region">State/region</label>
              <input name="region" type="text" v-model="region" />
              <p class="form__errors" v-if="errors.region">
                {{ errors.region }}
              </p>
            </div>
          </div>

          <div :class="['form__field', errors.birthdate && 'form__field--error']">
            <label for="birthdate">Date of birth</label>
            <input
              name="birthdate"
              type="text"
              placeholder="DD/MM/YYYY"
              v-model="birthdate"
              maxlength="10"
              @keyup="handleDate" 
            />
            <p class="form__errors" v-if="errors.birthdate">
              {{ errors.birthdate }}
            </p>
          </div>

          <div :class="['form__field', 'form__field--checkbox', errors.terms && 'form__field--error']">
            <input name="terms" type="checkbox" id="terms" v-model="terms" />
            <label for="terms" >
              <span>I agree to the </span>
              <a 
                href="https://www.eltonjohn.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                style="color: #FFFFFF;"
              >
                privacy policy
              </a>
            </label>
            <p class="form__errors" v-if="errors.terms">
              {{ errors.terms }}
            </p>
          </div>
          <p class="signup__recaptcha">This site is protected by reCAPTCHA and the Google <a target="_blank" rel="noopener noreferrer" href="https://policies.google.com/privacy">Privacy Policy</a> and <a target="_blank" rel="noopener noreferrer" href="https://policies.google.com/terms">Terms of Service</a> apply.</p>

        </form>

        <button 
          class="button button--primary signup__cta signup__cta--mobile"
          type="submit"
          form="signup-form"
          :disabled="!terms"
          v-if="!submitting"
        >
          Add brick now!
        </button>
        <div v-else class="signup__loader signup__cta--mobile"></div>

      </div>
    </transition>

    <transition mode="out-in" name="fade">
      <div v-if="success" class="signup__success container">
        <h2 class="signup__title">Your brick has been claimed!</h2>
        <p class="signup__text">Congratulations, you've claimed your brick on the Yellow Brick Road! Now, now feel free to explore the road to see who else has joined and discover hidden surprises along the way.</p>
        <button
          class="button button--primary"
          @click="viewBrick"
        >
          View your brick
        </button>
      </div>
    </transition>

    <transition mode="out-in" name="fade">
      <div v-if="error" class="signup__success container">
        <h2 class="signup__title">There was an error trying to submit your form</h2>
        <p class="signup__text">Please try again later</p>
      </div>
    </transition>

  </div>
</template>

<script>
import GoogleLogin from 'vue-google-login'
import facebookLogin from 'facebook-login-vuejs'
import { shortenNames } from '../assets/js/functions';

import axios from 'axios';
import * as Yup from 'yup'
import countries from '../lib/countries'


export default {
  name: 'Signup',

  components: {
    GoogleLogin,
    facebookLogin
  },

  data() {
    return {
      email: '',
      firstName: '',
      lastName: '',
      country: '',
      region: '',
      birthdate: '',
      terms: false,
      authenticationMethod: null,
      showForm: false,
      success: false,
      error: false,
      brickId: '',
      submitting: false,
      brickLabel: '',

      // Temp, required by API
      brickType: 1,

      // country options
      countries: countries,

      FB: undefined,

      // form validation errors
      errors: {},
    }
  },

  watch: {
    firstName() {
      this.brickLabel = shortenNames(this.firstName, this.lastName).split('\n');
    },
    lastName() {
      this.brickLabel = shortenNames(this.firstName, this.lastName).split('\n');
    },
  },

  computed: {
    googleClientId() {
      return process.env.VUE_APP_GOOGLE_CLIENT_ID
    },
    facebookAppId() {
      return process.env.VUE_APP_FACEBOOK_APP_ID
    },
    spotifyClientId() {
      return process.env.VUE_APP_SPOTIFY_CLIENT_ID
    },
    spotifyCallback() {
      return process.env.VUE_APP_SPOTIFY_CALLBACK
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL
    },
  },

  mounted() {
    // if this is spotify callback

    this.brickType = Math.floor(Math.random() * 3) + 1;
    this.token = window.location.hash
      .substr(1)
      .split('&')[0]
      .split('=')[1]
    if (this.token) {
      fetch('https://api.spotify.com/v1/me', {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      })
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.email = data.email
        this.country = data.country
        this.authenticationMethod = 'spotify';
      });
      window.history.replaceState(null, null, window.location.pathname);
      this.showForm = true;
    }
  },

  methods: {

    handleDate(){
      let v = this.birthdate;
      if (v.match(/^\d{2}$/) !== null) {
        this.birthdate = v + '/';
      } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
          this.birthdate = v + '/';
      }
    },

    goBack(){
      this.$emit('goBack', 'stage');
    },

    viewBrick(){
      window.location.href = this.baseUrl + '#' + this.brickId + '&claimed';
      window.location.reload();
    },
    
    setBrick(type) {
      if(type == 'prev'){
        this.brickType = this.brickType == 1 ? 3 : this.brickType - 1;
      } else {
        this.brickType = this.brickType == 3 ? 1 : this.brickType + 1;
      }
    },

    // Google
    googleSuccess(response) {
      console.log('success', response);
      this.email = response.getBasicProfile().getEmail();
      this.firstName = response.getBasicProfile().getGivenName();
      this.lastName = response.getBasicProfile().getFamilyName();
      this.authenticationMethod = 'google';
      this.showForm = true;
    },

    // Facebook
    facebookGetUserData() {
      this.FB.api(
        '/me',
        'GET',
        { fields: 'email, first_name, last_name' },
        userInformation => {
          this.email = userInformation.email;
          this.firstName = userInformation.first_name;
          this.lastName = userInformation.last_name;
          this.authenticationMethod = 'facebook';
        }
      )
    },

    facebookSdkLoaded(payload) {
      this.isConnected = payload.isConnected
      this.FB = payload.FB
      if (this.isConnected) this.facebookGetUserData()
    },

    facebookLogin() {
      this.isConnected = true
      this.facebookGetUserData()
      this.showForm = true;
    },

    // Spotify
    login() {
      window.location.replace(
        `https://accounts.spotify.com/authorize?response_type=token&redirect_uri=${this.spotifyCallback}&scope=user-top-read&client_id=${this.spotifyClientId}`,
        'Login with Spotify',
        'width=800,height=600'
      )
    },

    // Link
    setShowForm(){
      this.authenticationMethod = 'email';
      this.showForm = true;
    },

    async onSubmit(event) {
      event.preventDefault()

      await this.$recaptchaLoaded();
      const token = await this.$recaptcha();

      const values = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        country: this.country,
        region: this.region,
        birthdate: this.birthdate,
        terms: this.terms,
        brickType: this.brickType,
        authenticationMethod: this.authenticationMethod
      }

      const validationSchema = Yup.object({
        firstName: Yup.string().required('First name is required.'),
        lastName: Yup.string().required('Last name is required.'),
        email: Yup.string()
          .email()
          .required('Email is required.'),
        country: Yup.string().required('Country is required.'),
        region: Yup.string('Region must be a string.'),
        birthdate: Yup.string().matches(/\d{2}\/\d{2}\/\d{4}|^(?![\s\S])/, 'Date must be DD/MM/YYYY format'),
        terms: Yup.bool().oneOf([true], 'You must accept the terms.'),
        brickType: Yup.number().required('Brick type is required.'),
        authenticationMethod: Yup.string().required('Authentication method is required.')
      });

      // reset errors
      this.errors = {}

      try {
        await validationSchema.validate(values, { abortEarly: false })
      } catch (errors) {
        console.log(errors);
        this.errors = errors.inner.reduce((errors, error) => {
          errors[error.path] = error.message
          this.submitting = false;
          return errors
        }, {})
        return
      }

      this.submitting = true;

      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/submit`, {
          token,
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
          country: this.country,
          brickType: this.brickType,
          authenticationMethod: this.authenticationMethod,
          birthdate: this.birthdate,
          region: this.region
        });

        this.success = true;
        this.brickId = response.data.uid;
        this.submitting = false;
        //console.log(response);
      } catch (error) {
        this.error = true;
        setTimeout(() => {
          this.submitting = false;
          this.error = false;
        }, 2500)
        //console.log(error)
      }
    },
  },
}
</script>
